import { platformApiFetch } from '@/services/platformApi/client';
import { queryClient } from "@/lib/react-query";
import { clearBrowserAuthState, clearTransientBrowserState } from "@/utils/authStorage";
import { toast } from "sonner";

/**
 * Sign out the current user
 */
export const signOut = async () => {
  try {
    queryClient.clear();
    clearTransientBrowserState();
    clearBrowserAuthState();

    await platformApiFetch('/v1/auth/sign-out', {
      method: 'POST',
    });

    clearBrowserAuthState();
    clearTransientBrowserState();

    toast.success("Signed out", {
      description: "You have been successfully signed out."
    });
    
    // Redirect to home page after successful sign out
    window.location.href = '/';
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : 'An unexpected error occurred';
    console.error("Error during sign out:", error);
    clearBrowserAuthState();
    toast.error("Error signing out", {
      description: message
    });
    
    // Even in case of error, try to redirect to the home page
    // This ensures users don't get stuck in a logged-out state
    setTimeout(() => {
      window.location.href = '/';
    }, 1500);
    
    // Don't re-throw the error to prevent unhandled promise rejections
  }
};
